// nav icons
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LiveTvOutlinedIcon from '@mui/icons-material/LiveTvOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import LuggageOutlinedIcon from '@mui/icons-material/LuggageOutlined';

import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

const getIcon = (IconComponent) =>  (
  <IconComponent sx={{ color: "inherit", marginLeft: "auto" }} />
);

export const drawerWidth = 280; 
export const streamTypesArr =['rtsp', 'http', 'local', 'other'] 

export const navbarContentArr = [
  { text: "Dashboard", url: "/", icon: getIcon(DashboardOutlinedIcon) },
  { text: "Streams", url: "/streams", icon: getIcon(LiveTvOutlinedIcon) },
  { text: "Frames Search", url: "/frames-search", icon: getIcon(SearchOutlinedIcon) },
  { text: "Predictions", url: "/predictions", icon: getIcon(LightbulbOutlinedIcon) },
  { text: "Shoplifting", url: "/shoplifting", icon: getIcon(LocalPoliceOutlinedIcon) },
  { text: "No Entry Area", url: "/no-entry", icon: getIcon(DoNotDisturbOnOutlinedIcon) },
  { text: "Exit Blocking", url: "/exit-blocking", icon: getIcon(BlockOutlinedIcon) },
  { text: "Lost & Found", url: "/lost-found", icon: getIcon(LuggageOutlinedIcon), feature: "lost_found" },
  { text: "Charts", url: "/charts", icon: getIcon(BarChartIcon) },
  { text: "Logs", url: "/logs", icon:  getIcon(EditNoteOutlinedIcon) },
  { text: "Workspace", url: "/workspace/members", icon: getIcon(AdminPanelSettingsOutlinedIcon), superadminOnly: true },
  { text: "Setting", url: "/setting", icon: getIcon(SettingsOutlinedIcon) },
  { text: "Log out", url: false, icon: getIcon(LogoutOutlinedIcon) },
];


export const dataRenderTypeInSearchArr = [
  { value: "cards", icon: require('@mui/icons-material/DashboardOutlined').default },
  { value: "table", icon: require('@mui/icons-material/Toc').default },
];

  export const searchFramesColumns = [
    { field: "name", headerName: "Camera Name" },
    { field: "date", headerName: "Date" },
    { field: "time", headerName: "Time" },
    { field: "person_count", headerName: "Person Count" },
    { field: "male_count", headerName: "Male Count" },
    { field: "female_count", headerName: "female Count" },
    { field: "working_staff", headerName: "Working Staff" },
    // { field: "frame", headerName: "Image" }
  ];

 export const  streamColumns = [
  { field: "name", headerName: "Name" },
  { field: "type", headerName: "Type" },
  { field: "path", headerName: "Path" },
];

export const userRolesArr = ["user", "admin", "superadmin"];
export const workspaceRolesArr = ["admin", "member", "viewer"];

export const workspaceMembersColumns = [
  { field: "username", headerName: "Username" },
  { field: "email", headerName: "Email" },
  { field: "role", headerName: "Role" },
  { field: "actions", headerName: "Actions" },
];

export const featureKeysArr = [
  { value: "fire_smoke", label: "Fire & Smoke" },
  { value: "people_counting", label: "People Counting" },
  { value: "shoplifting", label: "Shoplifting" },
  { value: "no_entry_zone", label: "No Entry Zone" },
  { value: "blocked_exit", label: "Blocked Exit" },
  { value: "gender", label: "Gender" },
  { value: "lost_found", label: "Lost & Found" },
];

export const cameraModelsAdminColumns = [
  { field: "name", headerName: "Name" },
  { field: "path", headerName: "Path" },
  { field: "type", headerName: "Type" },
  { field: "models", headerName: "Detection Models" },
  { field: "actions", headerName: "Actions" },
];

export const cameraModelTypesArr = [
  { value: "fire_smoke", label: "Fire & Smoke" },
  { value: "shoplifting", label: "Shoplifting" },
  { value: "people_counting", label: "People Counting" },
  { value: "blocked_exit", label: "Blocked Exit" },
  { value: "no_entry_zone", label: "No Entry Zone" },
  { value: "lost_found", label: "Lost & Found" },
];


const generateUniqueColor = (index) => {
  const hue = (index * 137) % 360; 
  return `hsl(${hue}, 85%, 55%)`; 
};
export const chartColors = ["rgb(75, 192, 192)", "rgb(255, 99, 132)", "rgb(54, 162, 235)", "rgb(255, 206, 86)", ...Array.from({ length: 10 }, (_, i) => generateUniqueColor(i))];


export const BASE64_IMAGE_PREFIX = "data:image/jpeg;base64,";
export const baseURL = process.env.NODE_ENV === "production"? process.env.REACT_APP_API_URL_PROD: process.env.REACT_APP_API_URL_DEV;
export const StreamURL = process.env.NODE_ENV === "production"? process.env.REACT_APP_API_STREAM_PROD: process.env.REACT_APP_API_STREAM_DEV;


